<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BaseCheckboxList',
  mixins: [baseMixin],
  props: {
    items: {
      type: Array,
      required: true,
    },
    preselect: {
      type: Array,
      default: () => [],
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    itemLabel: {
      type: String,
      default: 'name',
    },
    disabledItems: {
      type: Array,
      default: () => [],
    },
  },
  data: () => {
    return {
      selected: [],
    }
  },
  watch: {
    preselect(n) {
      this.selected = n
    },
  },
  mounted() {
    this.selected = this.preselect
  },
}
</script>

<template>
  <article>
    <div
      v-for="item in items"
      :key="item[itemValue]"
      data-testid="base-checkbox-list-item"
    >
      <v-checkbox
        v-model="selected"
        :value="item[itemValue]"
        :disabled="disabledItems.includes(item[itemValue])"
        class="mb-0 mt-2"
        hide-details
        @change="$emit('updated', selected)"
      >
        <template v-slot:label="">
          <slot
            name="label"
            :item="item"
            :label="item[itemLabel]"
            :is-disabled="disabledItems.includes(item[itemValue])"
            >{{ item[itemLabel] }}</slot
          >
        </template>
      </v-checkbox>
    </div>
  </article>
</template>
